// import { Button } from "@mui/material";
import { Button } from "@material-ui/core";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";

export const getColumns = (columns, t) => {
  let updatedColumns = [];
  for (let column of columns) {
    updatedColumns.push({
      ...column,
      title: t(column?.title),
      field: column?.field,
      render: column?.render,
    });
  }

  return updatedColumns;
};

export const getOrdersActions = ({
  t,
  user,
  startTourCheck,
  startTour,
  addHandler,
  createHandover,
  importAction,
  atbasImportAction,
  routeLoading,
  handoverLoading,
}) => {
  const actions = [];

  const canStart =
    user?.permissions?.routes?.show_route_button &&
    (user?.permissions?.routesCreateForDriver ||
      user?.account_permissions?.create_driver ||
      user?.permissions?.routesCreateDeliveryOrder ||
      user?.account_permissions?.create_delivery);

  if (canStart) {
    const isDisabled = !startTourCheck() || routeLoading || handoverLoading;
    actions.push({
      icon: () => {
        return (
          <>
            <span
              style={{
                fontSize: "16px",
                fontWeight: "normal",
                color: isDisabled ? "#ADADAD" : "#6F9CEB",
                opacity: routeLoading || handoverLoading ? 0.6 : 1,
              }}
            >
              {routeLoading || handoverLoading ? t("Starting...") : t("Start")}
            </span>{" "}
            <PlayCircleOutlineIcon
              style={{
                marginLeft: "10px",
                color: isDisabled ? "#ADADAD" : "#6F9CEB",
                height: "20px",
                width: "20px",
                marginRight: "15px",
                opacity: routeLoading || handoverLoading ? 0.6 : 1,
              }}
            />
          </>
        );
      },
      tooltip: routeLoading || handoverLoading ? t("Starting...") : t("Start"),
      iconProps: { style: { color: "#ADADAD", background: "#1F1F1F" } },
      isFreeAction: true,
      onClick: () => !isDisabled && startTour(),
      position: "row",
    });
  }

  if (user?.permissions?.handovers?.create) {
    const isDisabled = !startTourCheck() || handoverLoading;
    actions.push({
      icon: () => {
        return (
          <>
            <span
              style={{
                fontSize: "16px",
                fontWeight: "normal",
                color: isDisabled ? "#ADADAD" : "#6F9CEB",
                opacity: handoverLoading ? 0.6 : 1,
              }}
            >
              {handoverLoading ? t("Creating...") : t("Create handover protocol")}
            </span>{" "}
            <PlayCircleOutlineIcon
              style={{
                marginLeft: "10px",
                color: isDisabled ? "#ADADAD" : "#6F9CEB",
                height: "20px",
                width: "20px",
                marginRight: "15px",
                opacity: handoverLoading ? 0.6 : 1,
              }}
            />
          </>
        );
      },
      tooltip: handoverLoading ? t("Creating handover...") : t("Create handover protocol"),
      iconProps: { style: { color: "#ADADAD", background: "#1F1F1F" } },
      isFreeAction: true,
      onClick: () => !isDisabled && createHandover(),
      position: "row",
    });
  }

  if (user?.permissions?.orders?.import) {
    actions.push({
      icon: () => (
        <Button color="primary" size="small" variant="contained" onClick={importAction} style={{ marginLeft: "10px" }}>
          {t("Import Orders")}
        </Button>
      ),
      isFreeAction: true,
      onClick: () => { },
      position: "toolbar",
    });
  }
  if (user?.permissions?.orders?.atbas_scan_import) {
    actions.push({
      icon: () => (
        <Button
          color="primary"
          size="small"
          variant="contained"
          onClick={atbasImportAction}
          style={{ marginLeft: "10px" }}
        >
          {t("atbas_scan_import")}
        </Button>
      ),
      isFreeAction: true,
      onClick: () => {},
      position: "toolbar",
    });
  }
  if (user?.permissions?.ordersCreate || user?.permissions?.orders?.create) {
    actions.push({
      icon: "add",
      iconProps: {
        style: { color: "#1F1F1F", background: "#6F9CEB", marginRight: "15px" },
      },
      isFreeAction: true,
      onClick: addHandler,
      position: "row",
    });
  }

  return actions;
};

export const getActions = (
  tableTitle,
  callbackOnDelete,
  addHandler,
  editHandler,
  startTourCheck,
  startTour,
  t,
  user = {},
  exportAction = null,
  importAction = null
) => {
  const actions = [];
  const permissions = user?.permissions || {};

  if (tableTitle === "CUSTOMERS" && permissions.customers?.export) {
    actions.push({
      icon: () => (
        <Button color="primary" size="small" variant="contained" onClick={exportAction} style={{ marginLeft: "10px" }}>
          {t("Export Customers")}
        </Button>
      ),
      isFreeAction: true,
      onClick: () => { },
      position: "toolbar",
    });
  }

  const canAdd =
    (tableTitle === "CUSTOMERS" && (permissions.customersCreate || permissions.customers?.create)) ||
    (tableTitle === "TOURS" && (permissions.toursCreate || permissions.tours?.create)) ||
    (tableTitle === "SUPPLIERLOCATIONS" && permissions?.admin?.supplier_locations) ||
    (tableTitle === "SUPPLIERGROUPS" && permissions?.admin?.supplier_groups) ||
    (tableTitle === "SUPPLIERS" && permissions?.admin?.supplier) ||
    (tableTitle === "USERS" && permissions?.user?.create) ||
    (tableTitle === "ROLES" && permissions?.admin?.roles);

  if (permissions?.customers?.bulk_import && importAction) {
    actions.push({
      icon: () => (
        <Button color="primary" size="small" variant="contained" onClick={importAction} style={{ marginLeft: "10px" }}>
          {t("Import Customers")}
        </Button>
      ),
      isFreeAction: true,
      onClick: () => { },
      position: "toolbar",
    });
  }
  if (canAdd) {
    actions.push({
      icon: "add",
      tooltip: t("Add"),
      iconProps: {
        style: {
          color: "#1F1F1F",
          background: "#6F9CEB",
          marginRight: "15px",
        },
      },
      isFreeAction: true,
      onClick: addHandler,
      position: "row",
    });
  }

  return actions;
};

export const getLocalization = (t) => {
  return {
    pagination: {
      labelRowsSelect: t("rows"),
      labelDisplayedRows: `{from}-{to} ${t("of")} {count}`,
      nextTooltip: t("Next page"),
      lastTooltip: t("Last page"),
      previousTooltip: t("Previous page"),
      firstTooltip: t("First page"),
    },
    toolbar: {
      nRowsSelected: `{0} ${t("row(s)")} ${t("selected")}`,
      searchTooltip: t("Search"),
      searchPlaceholder: t("Search"),
    },
    header: {
      actions: t("Actions"),
    },
    body: {
      emptyDataSourceMessage: t("No records to display"),
      filterRow: {
        filterTooltip: t("Filter"),
      },
    },
  };
};
